import { render } from "./AttachmentControl.vue?vue&type=template&id=0c08af2e&ts=true"
import script from "./AttachmentControl.vue?vue&type=script&lang=ts"
export * from "./AttachmentControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__